(function () {
  'use strict';

  var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Mobiel menu ---------- */
  var menuBtn = qs('[data-menu-toggle]');
  var nav = qs('[data-mobile-nav]');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Zoeken ---------- */
  var searchBtn = qs('[data-search-toggle]');
  var searchPanel = qs('[data-search-panel]');
  if (searchBtn && searchPanel) {
    var closeSearch = function () {
      searchPanel.classList.remove('is-open');
      searchBtn.setAttribute('aria-expanded', 'false');
    };
    searchBtn.addEventListener('click', function () {
      var open = searchPanel.classList.toggle('is-open');
      searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = qs('input[type="search"]', searchPanel);
        if (input) { input.focus(); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSearch(); }
    });
  }

  /* ---------- Productpagina ---------- */
  qsa('[data-product]').forEach(function (root) {
    var slides = qsa('[data-media]', root);
    var thumbs = qsa('[data-thumb]', root);

    function showMedia(id) {
      if (!id) { return; }
      var found = false;
      slides.forEach(function (s) {
        var match = s.getAttribute('data-media-id') === String(id);
        if (match) { found = true; }
      });
      if (!found) { return; }
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id));
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
    });

    var select = qs('[data-variant-select]', root);
    var price = qs('[data-price]', root);
    var compare = qs('[data-compare]', root);
    var addBtn = qs('[data-add]', root);
    var addLabel = qs('[data-add-label]', root);

    if (select && select.tagName === 'SELECT') {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (price) { price.textContent = opt.getAttribute('data-price'); }
        if (compare) {
          var c = opt.getAttribute('data-compare');
          compare.textContent = c || '';
          compare.hidden = !c;
        }
        var available = opt.getAttribute('data-available') === 'true';
        if (addBtn) { addBtn.disabled = !available; }
        if (addLabel) { addLabel.textContent = available ? 'In winkelwagen' : 'Uitverkocht'; }
        showMedia(opt.getAttribute('data-media-id'));
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    }

    var qty = qs('[data-qty]', root);
    var minus = qs('[data-qty-minus]', root);
    var plus = qs('[data-qty-plus]', root);
    if (qty && minus && plus) {
      minus.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      });
      plus.addEventListener('click', function () {
        qty.value = (parseInt(qty.value, 10) || 1) + 1;
      });
    }
  });

  /* ---------- Winkelwagen: automatisch bijwerken ---------- */
  var cartForm = qs('[data-cart-form]');
  if (cartForm) {
    qsa('[data-cart-qty]', cartForm).forEach(function (input) {
      input.addEventListener('change', function () { cartForm.submit(); });
    });
  }

  /* ---------- Collectie: filters en sortering ---------- */
  var filterForm = qs('[data-filters]');
  var sortSelect = qs('[data-sort]');

  function applyFilters() {
    var params = new URLSearchParams();
    if (filterForm) {
      new FormData(filterForm).forEach(function (value, key) {
        if (value !== '') { params.append(key, value); }
      });
    }
    if (sortSelect && sortSelect.value) { params.set('sort_by', sortSelect.value); }
    var query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  }

  if (filterForm) {
    filterForm.addEventListener('change', applyFilters);
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(); });
  }
  if (sortSelect) {
    sortSelect.addEventListener('change', applyFilters);
  }
})();
